export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mot de passe"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continuer"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saisir le mot de passe de confirmation"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mot de passe de confirmation"])}
}